import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { DashboardRoutes } from '../dashboard/dashboard.routing';
import { AutenticacaoService } from '../services/autenticacao.service';
import { CarregandoService } from '../services/carregando.service';
import { GlobalService } from '../services/global.service';
import { FuncionarioService } from '../services/funcionario.service';
import { PremissasService } from '../services/premissas.service';

/* Classe para controlar acesso */

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  administrador = false;

  constructor(
    private router: Router,
    private autenticacaoService: AutenticacaoService,
    private carregandoService: CarregandoService,
    private globalService: GlobalService,
    private funcionarioService: FuncionarioService,
    private premissaService: PremissasService,
    private authenticationService: AutenticacaoService
  ) { }

  validarCodEverest(permissao): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.carregandoService.mostra('buscarCodEverest');
    });
  }

  async canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    const accessToken = this.authenticationService.obterToken();

    if (accessToken != null) {
      const roles = next.data.roles as Array<string>;
      const linkVenda = next.data.linkVenda;
      const permissao = next.data.permissao;

      const usuarioLogado = await this.globalService.consultaUsuario(true);
      this.administrador = await this.globalService.administrador(true);

      if (roles) {
        const match = this.autenticacaoService.roleMatch(roles, usuarioLogado.roles);

        if (match) {
          if (this.autenticacaoService.isIntegrador(usuarioLogado.roles)) return true;

          if (permissao) {
            if (permissao.codEverest) {
              return this.premissaService.consultarCodEverest().map(res => {
                if (res.valor == permissao.codEverest) {
                  return true;
                } else {
                  this.router.navigate(['/proibido'], { state: { permissao } });
                }
              }
              ).toPromise();
            } else {
              return this.funcionarioService.possuiAcessoNaTela(
                permissao.sistema,
                permissao.tela, permissao.pai,
                linkVenda ? next.params.id : '').map(res => {

                  if (!res.acesso) {
                    let pSistema = '';
                    let pLink = '';

                    switch (permissao.sistema) {
                      case 'gi':
                        if (permissao.pai === null) {
                          this.router.navigate(['/proibido'], { state: { permissao } });
                        } else {
                          switch (permissao.pai) {
                            case 'configuracoes':
                              this.router.navigate(['/proibido'], { state: { permissao } });
                              break;

                            default:
                              this.router.navigate(['/proibido'], { state: { permissao } });
                              break;
                          }
                        }
                        break;
                      default:
                        return true;
                    }
                  } else {
                    return true;
                  }
                }).toPromise();
            }
          } else return true;
        } else {
          this.router.navigate(['/proibido']);

          return false;
        }
      } else {
        return true;
      }
    } else {
      this.router.navigate(['/login']);
      return false;
    }
  }
}
